import { defineMessages } from 'react-intl'

const scope = `procurify.platform.legal-entities.pages`

export default defineMessages({
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  manageEntitiesTitle: {
    id: `${scope}.manageEntitiesTitle`,
    defaultMessage: 'Entities',
  },
})
